var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { ref: "modal" }, [
    _vm.issue
      ? _c("h3", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
          _c("i", { staticClass: "fas fa-comments" }),
          _vm._v(
            " " +
              _vm._s(
                _vm.resource("SprintPlanning_Comments_Comments_DisplayName")
              ) +
              " " +
              _vm._s(_vm.issue.issueId) +
              "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.ready
      ? _c("div", { attrs: { slot: "modal-body" }, slot: "modal-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "description-header" }, [
                _c("h4", [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "SprintPlanning_Comments_Description_DisplayName"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.issue
                ? _c("div", { staticClass: "description" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.parseString(_vm.issue.description)
                        )
                      }
                    })
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.comments
            ? _c(
                "div",
                _vm._l(_vm.comments, function(comment) {
                  return _c("div", { key: comment.id, staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "comment-header" }, [
                        _c("span", { staticClass: "author" }, [
                          _vm._v(_vm._s(comment.author.displayName))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "created" }, [
                          _vm._v(_vm._s(_vm.dateString(comment.created)))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "comment-body" }, [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(_vm.parseString(comment.body))
                          }
                        })
                      ])
                    ])
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canAddComments
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "add-comment" },
                    [
                      _c("add-comment", { ref: "addComment" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary pull-right mt-2",
                          on: {
                            click: function($event) {
                              return _vm.addComment()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.resource("Button_Add")) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          on: {
            click: function($event) {
              return _vm.$refs.modal.hide()
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _vm._v(" " + _vm._s(_vm.resource("Button_Close")) + "\n        ")
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }